import { fetch as fetchPolyfill } from 'whatwg-fetch'

const Http = {}
const methods = ['get', 'post', 'put', 'delete'] // 支持的方法

/**
 * 把对象序列化成url参数形式
 * @param  {object} obj 需要序列化的对象
 * @return {string}     {a:1,b:2} ==> ?a=1&b=2
 */
function serialiseObject(obj) {
  /* eslint-disable prefer-template */
  if (obj && Object.keys(obj).length) {
    return '?' + Object.keys(obj).map(key =>
      key + '=' + encodeURIComponent(obj[key])).join('&')
  }

  return ''
}

function getUrl(path, params) {
  if (!path) {
    throw new Error('path is required')
  }

  if (path.startsWith('http')) {
    return path + serialiseObject(params)
  }

  return process.env.VUE_APP_API_HOST + path + serialiseObject(params)
}

function checkStatus(res) {
  if (res.status === 204) {
    return null
  }

  if (res.status === 401) {
    res.json().then((response) => {
      console.log(response, 'from signin template')
      const { code } = response
      if (code >= 10 && code <= 12) {
        loginManager.platform('wx').logout()
        loginManager.platform('wx').check()
      }
      if (code >= 20 && code <= 22) {
        loginManager.platform('qqconnect').logout()
        loginManager.platform('qqconnect').check()
      }
      if (code === 23) {
        alert('当前登陆QQ身份与角色绑定不一致, 请重新登录')
        loginManager.platform('qqconnect').logout()
        loginManager.platform('qqconnect').check()
      }
      return false
    })
  }

  if (res.ok) {
    return res.json()
  }

  return res.json().then((err) => { throw err })
}


methods.forEach((method) => {
  Http[method] = (
    options = {},
    config = {},
  ) => fetchPolyfill(
    getUrl(options.path, options.params),
    {
      credentials: 'include',
      method,
      body: JSON.stringify(options.data),
      ...config,
    },
  )
    .then(checkStatus)
})

export default Http
